import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import ElementaryProgressReportDao from "../dao/ElementaryProgressReportDao";

import { subjectIdToContentAreaId } from "../utils/SchoolAdmin/translations";

const useStudentDifferentiation = ({
    student,
    selectedTemplate,
    selectedEpr,
    navMode,
    effectiveGradingCriteriaId,
    token
}) => {
    const [diffGrades, setDiffGrades] = useState([]);
    const [diffRatings, setDiffRatings] = useState([]);
    const [reportableContent, setReportableContent] = useState(null);

    // Fetch student differentiation data
    useEffect(() => {
        if (!student || !selectedTemplate || !effectiveGradingCriteriaId) return;

        const options = {
            action: "getStudentDiff",
            gradingProfileStudentId: student.gradingProfileStudentId,
            params: {
                gradingCriteriaId: effectiveGradingCriteriaId
            },
            token
        };

        ElementaryProgressReportDao(options)
            .then((response) => {
                if (response?.data?.payload && response.data.payload.length > 0) {
                    const ratings = response.data.payload[0]?.diffRatings || [];
                    const grades = [...new Set(ratings.map((dR) => dR.grade).filter(Boolean))].sort((a, b) =>
                        a.localeCompare(b)
                    );
                    setDiffRatings(ratings);
                    setDiffGrades(grades);
                } else {
                    setDiffRatings([]);
                    setDiffGrades([]);
                }
            })
            .catch((error) => {
                toast.error("Unable to retrieve student differentiation data.");
                console.error(error);
            });
    }, [effectiveGradingCriteriaId, navMode, selectedTemplate, selectedEpr, student, token]);

    // Fetch reportable content for differentiation grades
    useEffect(() => {
        if (
            selectedTemplate &&
            diffGrades?.length > 0 &&
            (!reportableContent || (reportableContent && diffGrades.length !== reportableContent.gradeLevels.length))
        ) {
            const options = {
                action: "eprReportableByContentAreaAndGrades",
                contentAreaKey: subjectIdToContentAreaId[selectedTemplate.subjectId],
                gradeLevels: diffGrades.join(","),
                token
            };
            ElementaryProgressReportDao(options)
                .then((response) => {
                    if (response) {
                        const { payload } = response.data;
                        setReportableContent(payload);
                    }
                })
                .catch((error) => {
                    toast.error("Unable to retrieve content for differentiation.");
                    console.error(error);
                });
        }
    }, [diffGrades, reportableContent, selectedTemplate, token]);

    return {
        diffGrades,
        diffRatings,
        reportableContent,
        setDiffGrades,
        setDiffRatings,
        setReportableContent
    };
};

export default useStudentDifferentiation;
